import { render, staticRenderFns } from "./PageShow.vue?vue&type=template&id=4dd75aee&"
import script from "./PageShow.vue?vue&type=script&lang=js&"
export * from "./PageShow.vue?vue&type=script&lang=js&"
import style0 from "./PageShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports